/**
 * <s-glossary-terms> — desktop product page Glossary row (snippets/product-glossary-terms.liquid).
 * On desktop (≥768px) a Glossary spec link (button[command="--glossary-open"], snippets/glossary-term-link)
 * whose term is listed in this row scrolls here and gently highlights the entry (0.8s, calm motion rule)
 * instead of opening the full-library drawer. Other links, and phones, keep the drawer.
 */
class SGlossaryTerms extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const desktop = window.matchMedia('(min-width: 48rem)');
    const more = this.querySelector('[data-gt-more]');
    const toggle = this.querySelector('[data-gt-more-toggle]');
    this._setMore = (open) => {
      if (!toggle) return;
      this.toggleAttribute('data-open', open);
      if (more) more.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('[data-gt-more-label]').hidden = open;
      toggle.querySelector('[data-gt-less-label]').hidden = !open;
    };
    toggle?.addEventListener('click', () => this._setMore(!this.hasAttribute('data-open')), { signal: this.#ac.signal });
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const link = e.target.closest('button[command="--glossary-open"]');
      if (!link || !link.value) return;
      const entry = this.querySelector(`#pdp-term-${CSS.escape(link.value)}`);
      if (!entry) return;
      e.preventDefault();
      if (!this.hasAttribute('data-open') && getComputedStyle(entry).display === 'none' || entry.closest('[data-gt-more]')?.hidden) this._setMore(true);
      const details = this.closest('details');
      if (details && !details.open) details.open = true;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      entry.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      entry.removeAttribute('data-active');
      requestAnimationFrame(() => entry.setAttribute('data-active', ''));
      clearTimeout(this._t);
      this._t = setTimeout(() => entry.removeAttribute('data-active'), 2400);
    }, { capture: true, signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-glossary-terms')) customElements.define('s-glossary-terms', SGlossaryTerms);
